import { Conditional } from '@cat-ecom/pcc-components';
import ViewReplacement from 'components/actions/view-replacement/view-replacement';
import { RELATED_PARTS_GA_LIST_NAME } from '../../constants/constants';
import AddToCart from 'components/actions/add-to-cart/add-to-cart';
import { MergedPriceAndAvailabilityResponse } from 'services/dealerPriceAvailability/types';
import { CartResponse } from 'services/cart/types';

export const AddToCartSection: React.FC<{
  part: MergedPriceAndAvailabilityResponse;
  cartDetails: CartResponse;
  storeLocationId: string;
  currency: string;
  isHeadlessPDPEnabled: boolean;
  catcorp?: boolean;
}> = ({
  part,
  cartDetails,
  storeLocationId,
  currency,
  isHeadlessPDPEnabled
}) => {
  const { partNumber, replacementParts, seoURL, productURL } = part;

  return (
    <div className="d-flex justify-content-end">
      <Conditional
        test={replacementParts?.length === 0}
        fallback={
          <div>
            <ViewReplacement
              partNumber={partNumber}
              productURL={seoURL ?? productURL}
              isHeadlessPDPEnabled={isHeadlessPDPEnabled}
            />
          </div>
        }
      >
        <div>
          <AddToCart
            typeIcon={false}
            isAddToCartMobile={true}
            productPrice={part}
            size="md"
            fullWidth={false}
            productPriceData={part}
            cartId={cartDetails?.orderHeader?.orderId}
            locationId={storeLocationId}
            currency={currency}
            itemlistIdName={RELATED_PARTS_GA_LIST_NAME}
          />
        </div>
      </Conditional>
    </div>
  );
};
